import React from 'react';
import type { EacLogItem } from '../types';

interface LogPanelProps {
  logItems: EacLogItem[];
}

const ProcessIcon: React.FC = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className="h-[16px] w-[16px]"
      aria-hidden="true"
    >
      <path
        d="M792.768 815.872a480 480 0 0 1-131.968 92.608c-50.816 24.128-99.328 36.16-145.536 36.16-57.216 0-111.744-11.52-163.584-34.688a397.376 397.376 0 0 1-130.88-93.632 99.456 99.456 0 0 1-39.104 8.512c-32.448 0-60.16-11.52-83.2-34.56C75.52 767.36 64 739.648 64 707.2c0-21.248 5.376-41.024 16.192-59.456 9.664-16.448 22.464-29.696 38.4-39.808a400.896 400.896 0 0 1-5.376-65.28c0-90.56 27.136-171.584 81.408-243.2a390.528 390.528 0 0 1 206.272-142.208c5.376-25.728 18.304-47.36 38.72-64.896A113.92 113.92 0 0 1 515.968 64c28.992 0 54.528 9.472 76.608 28.416 20.48 17.6 33.28 39.36 38.592 65.216a390.72 390.72 0 0 1 205.184 142.464 392.192 392.192 0 0 1 80.96 242.56c0 23.552-2.688 47.296-7.936 71.104 13.568 10.368 24.448 23.296 32.576 38.592 9.088 17.216 13.632 35.456 13.632 54.784 0 31.552-12.928 59.328-38.784 83.52-24.32 22.784-50.688 34.176-78.912 34.176-15.744 0-30.72-3.008-45.12-8.96z m-219.52-634.368a55.232 55.232 0 0 0-16.896-40.32 55.168 55.168 0 0 0-40.32-16.768 55.168 55.168 0 0 0-40.32 16.64 55.36 55.36 0 0 0-17.024 40.192v0.704c0 12.032 3.52 22.912 10.496 32.768a56.32 56.32 0 0 0 46.784 24.32c11.712 0 23.936-5.76 36.736-17.344 12.8-11.648 19.712-24.064 20.48-37.312l0.064-2.368v-0.512z m287.232 411.264l0.128-0.384a205.824 205.824 0 0 1-0.128 0.384zM173.632 542.592a339.072 339.072 0 0 0 3.2 46.976l4.864-0.128c32.448 0 60.16 11.52 83.2 34.56 22.976 22.976 34.496 50.688 34.496 83.2a106.88 106.88 0 0 1-29.248 73.408 337.28 337.28 0 0 0 108.224 75.136c43.52 19.008 89.088 28.48 136.896 28.48 37.376 0 77.12-9.92 119.232-29.824a416.256 416.256 0 0 0 109.952-75.776 113.472 113.472 0 0 1-24.256-71.488c0-32.448 11.52-60.16 34.56-83.2 22.976-22.976 50.688-34.496 83.136-34.496 4.8 0 9.6 0.32 14.336 0.896h0.256c2.944-16 4.48-32 4.48-47.744a333.696 333.696 0 0 0-66.176-202.432 331.52 331.52 0 0 0-164.416-120.704 124.16 124.16 0 0 1-42.496 54.976c-22.016 16.64-44.608 24.96-67.84 24.96-27.2 0-51.456-8.448-72.768-25.216a114.56 114.56 0 0 1-38.848-54.848A331.648 331.648 0 0 0 239.872 339.84a333.76 333.76 0 0 0-66.24 202.816z m623.744 124.032a55.168 55.168 0 0 0-16.768 40.512 54.4 54.4 0 0 0 24.064 46.592c9.984 7.168 21.12 10.752 33.216 10.752 11.712 0 23.936-5.76 36.736-17.344 13.696-12.416 20.544-25.728 20.544-40a55.936 55.936 0 0 0-9.024-30.72 56.384 56.384 0 0 0-24.256-21.248 56.576 56.576 0 0 0-24-5.312 55.168 55.168 0 0 0-40.512 16.768z m-615.68-16.768c-6.4 0-12.8 1.088-19.008 3.328a56.128 56.128 0 0 0-27.776 20.928 55.808 55.808 0 0 0-10.496 33.024c0 15.808 5.568 29.312 16.768 40.512a55.168 55.168 0 0 0 40.512 16.832c8.512 0 18.112-3.712 28.672-11.072 19.072-13.184 28.608-28.608 28.608-46.272a55.168 55.168 0 0 0-16.768-40.448 55.168 55.168 0 0 0-40.512-16.832z"
        p-id="2859"
        fill="#F5A623"
      ></path>
    </svg>
  );
};

const SuccessIcon: React.FC = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className="h-[14px] w-[14px]"
      aria-hidden="true"
    >
      <path
        d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m295.53 339.55l-313.17 382-21.6 26.34a50.46 50.46 0 0 1-7.17 7.15c-0.65 0.52-1.3 1-2 1.51-1.08 0.79-2.19 1.52-3.32 2.22-0.57 0.35-1.15 0.69-1.73 1s-1.26 0.7-1.91 1c-1.2 0.61-2.43 1.18-3.67 1.69a51 51 0 0 1-5.05 1.74c-1.38 0.39-2.77 0.74-4.17 1a50.812 50.812 0 0 1-9.47 0.95h-0.07a51.39 51.39 0 0 1-7.19-0.5 49.67 49.67 0 0 1-20.53-7.8 48.89 48.89 0 0 1-4.11-3L200.19 589a50 50 0 0 1-7-70.37 50 50 0 0 1 70.37-7l124.91 102.46a50 50 0 0 0 70.36-7l271.36-331a50 50 0 0 1 70.37-7 50 50 0 0 1 6.97 70.46z"
        fill="#0cd311"
      />
    </svg>
  );
};

const RunningIcon: React.FC = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className="h-[14px] w-[14px] animate-spin"
      aria-hidden="true"
    >
      <path
        d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z"
        fill="#129bfe"
      />
      <path
        d="M220.891429 455.606857l88.941714 106.642286a26.843429 26.843429 0 0 1-3.218286 37.595428 26.258286 26.258286 0 0 1-37.156571-3.218285l-22.308572-26.697143c24.502857 130.633143 138.24 229.522286 274.724572 229.522286a277.942857 277.942857 0 0 0 216.649143-103.862858 31.451429 31.451429 0 0 1 44.617142-4.608 32.182857 32.182857 0 0 1 4.388572 45.056 341.065143 341.065143 0 0 1-265.654857 127.414858c-181.906286 0-330.898286-143.213714-342.308572-324.022858l-47.616 57.197715a26.258286 26.258286 0 0 1-37.229714 3.218285 26.843429 26.843429 0 0 1-3.145143-37.595428L180.516571 455.68a26.258286 26.258286 0 0 1 40.374858 0z m300.982857-284.964571c169.106286 0 310.637714 129.974857 337.554285 295.936l32.621715-39.058286a26.258286 26.258286 0 0 1 37.229714-3.218286c11.117714 9.508571 12.580571 26.331429 3.145143 37.595429l-88.941714 106.642286a26.258286 26.258286 0 0 1-40.374858 0L714.166857 461.897143a26.843429 26.843429 0 0 1 3.218286-37.595429c11.117714-9.508571 27.794286-8.045714 37.156571 3.218286l42.642286 51.053714c-21.357714-136.704-137.508571-243.931429-275.309714-243.931428-72.996571 0-141.604571 28.379429-193.316572 78.409143a31.451429 31.451429 0 0 1-44.763428-0.950858 32.182857 32.182857 0 0 1 0.950857-45.275428 340.114286 340.114286 0 0 1 237.129143-96.182857z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

const PendingDot: React.FC = () => {
  return <span className="block h-[8px] w-[8px] rounded-full bg-[#d1d5db]" />;
};

interface LogItemRowProps {
  item: EacLogItem;
}

const LogItemRow: React.FC<LogItemRowProps> = ({ item }) => {
  const [entered, setEntered] = React.useState(false);

  React.useEffect(() => {
    // 新日志项挂载后触发一次淡入，避免列表出现过于生硬。
    const rafId = window.requestAnimationFrame(() => {
      setEntered(true);
    });

    return () => {
      window.cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      className={`flex min-h-[42px] items-center rounded-[6px] border border-solid border-[#d9dee7] bg-white px-4 py-2 transition-all duration-300 ease-out ${
        entered ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'
      }`}
    >
      <div className="mr-3 shrink-0 relative top-[1px]">
        <ProcessIcon />
      </div>
      <div className="min-w-0 flex-1 truncate text-[12px] leading-5 text-[#1f2937]">
        {item.name}
      </div>
      <div className="ml-3 flex shrink-0 items-center gap-1">
        {item.status === 'completed' ? (
          <SuccessIcon />
        ) : item.status === 'running' ? (
          <>
            <span className="text-[10px] leading-4 text-[#129bfe]">
              running
            </span>
            <RunningIcon />
          </>
        ) : (
          <>
            <span className="text-[10px] leading-4 text-[#9ca3af]">
              pending
            </span>
            <PendingDot />
          </>
        )}
      </div>
    </div>
  );
};

const LogPanel: React.FC<LogPanelProps> = ({ logItems }) => {
  return (
    <aside className="flex h-full w-full flex-col border-0 border-l border-solid border-[#d1d5db] bg-slate-50">
      <div className="shrink-0 px-6 pt-6 pb-3 text-[14px] font-bold leading-6 text-[#111827]">
        运行日志
      </div>
      <div className="thin-scrollbar min-h-0 flex-1 overflow-y-auto bg-slate-50 px-4 pb-4">
        <div className="flex flex-col gap-[10px]">
          {logItems.map(item => (
            <LogItemRow key={item.key} item={item} />
          ))}
        </div>
      </div>
    </aside>
  );
};

export default LogPanel;
